module.exports = __webpack_public_path__ + "img/al.48989ca4.svg";